import Core from './core'
import Presenter from './presenter'
import Activities from './activities'
import Slideware from './slideware'
import Backbone from '@polleverywhere/backbone'
import Reports from './reports'
import Participant from './participant'
import Embed from './embed'
import Auth from './auth'
import Viz from './viz'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'
import listenToSelector from '../../util/listen_to_selector'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'

function tryToStartPushState () {
  const { options } = store.getState()[appSlice.name]
  if (!Backbone.History.started) {
    Backbone.history.start({
      pushState: options.pushState
    })

    return true
  }

  return false
}

/**
 * Initialize routers
 */
export default (app) => {
  const dispatcher = _.clone(Backbone.Events)
  dispatcher.listenTo(app, 'reset:state', (state) => {
    const { role, mode } = store.getState()[appSlice.name]
    // Clear the handlers since we're creating a new router
    Backbone.history.handlers = []

    switch (role) {
      case 'presenter':
        new Core({ state }) // eslint-disable-line no-new
        new Presenter({ state }) // eslint-disable-line no-new
        new Activities({ state }) // eslint-disable-line no-new
        new Reports({ state }) // eslint-disable-line no-new

        // TODO: deprecate this when we get rid of integration mode
        // turn on integration routes
        if (mode === 'integration') {
          new Slideware({ state }) // eslint-disable-line no-new
        }
        break

      case 'slideware':
        new Core({ state }) // eslint-disable-line no-new
        new Presenter({ state }) // eslint-disable-line no-new
        new Activities({ state }) // eslint-disable-line no-new
        new Reports({ state }) // eslint-disable-line no-new
        new Slideware({ state }) // eslint-disable-line no-new

        break

      case 'agave':
        new Core({ state }) // eslint-disable-line no-new
        new Activities({ state }) // eslint-disable-line no-new
        break

      case 'participant':
        new Core({ state }) // eslint-disable-line no-new
        new Participant({ state }) // eslint-disable-line no-new
        break

      case 'embed':
        new Embed({ state }) // eslint-disable-line no-new
        break

      case 'auth':
        new Auth({ state }) // eslint-disable-line no-new
        break

      case 'viz':
        new Viz({ state }) // eslint-disable-line no-new
        break
    }

    listenToSelector((state) => state[profileSlice.name].participant?.id, (id) => {
      if (id) {
        // don't trigger page changing if page is ready already
        if (Backbone.History.started && store.getState()[appSlice.name].ready) {
          return
        }

        if (!tryToStartPushState()) {
          // Trigger default route
          store.dispatch(appSlice.pageUpdatedToDefault())
        }
      }
    })

    const { options } = store.getState()[appSlice.name]

    if (!options.shouldStartSessionOnStart) {
      tryToStartPushState()
    }
  })
}
